import { useState } from 'react'
import provider from './provider'

// const api_endpoint = (process.env.NODE_ENV == 'production' && 'https://api.perfectsen.se/api/') || 'https://api.perfectsen.se/api/'
const api_endpoint = (process.env.NODE_ENV == 'production' && 'https://api.perfectsen.se/api/') || 'http://localhost:8009/api/'

export const tranformFn = ({ url, data, reject }) => {
    let value = data
    console.log({ data })
    switch (true) {
        case !!data?.error_array?.length:
            data.error_array.map(console.error)
            reject({ data })
            break
        case !!data?.[0]?.error_array?.length:
            data[0].error_array.map(console.error)
            reject({ data })
            break
        case data?.[0]?.success === false:
            console.error({ data })
            reject({ data })
            break
        case url && url.substring(0, 22) === 'provider/amazon/search' && Array.isArray(data):
            value = data.map(provider.amazon.getNormalizedProduct)
            break
        case url && url.substring(0, 31) === 'provider/amazon/product_details':
            value = (Array.isArray(data) && data.map(provider.amazon.getNormalizedProduct)) || provider.amazon.getNormalizedProduct(data)
            break
    }
    return value
}

export const get = (url) => {
    return new Promise((resolve, reject) =>
        fetch(url.substring(0, 4) === 'http' ? url : api_endpoint + url, {
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: 'Bearer ' + localStorage.getItem('api_token') },
        })
            .then((r) => r.json())
            .then((data) => resolve(tranformFn({ url, data, reject })))
    )
}
export const post = (url, params = {}) => {
    // console.log(params)
    return fetch(url.substring(0, 4) === 'http' ? url : api_endpoint + url, {
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: 'Bearer ' + localStorage.getItem('api_token') },
        method: 'POST',
        body: JSON.stringify(params),
    })
        .then((r) => r.json())
}
export const put = (url, params = {}) => {
    return fetch(url.substring(0, 4) === 'http' ? url : api_endpoint + url, {
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: 'Bearer ' + localStorage.getItem('api_token') },
        method: 'PUT',
        body: JSON.stringify(params),
    })
        .then((r) => r?.json())
}
export const del = (url, params = {}) => {
    return fetch(url.substring(0, 4) === 'http' ? url : api_endpoint + url, {
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: 'Bearer ' + localStorage.getItem('api_token') },
        method: 'DELETE',
    })
}
export const upload = (url, params = {}) => {
    console.log(params)
    return fetch(url.substring(0, 4) === 'http' ? url : api_endpoint + url, {
        headers: { 'Content-Type': 'application/json', Accept: 'application/vnd.api+json', Authorization: 'Bearer ' + localStorage.getItem('api_token') },
        method: 'POST',
        body: JSON.stringify(params),
    })
}

export const useApi = () => {
    const trigger = (method) => (url, params = {}) => {
        setState({ ...state, isLoading: true })
        return new Promise((resolve) => {
            method(url, params).then((r) => {
                setState({ ...state, isLoading: false, response: r })
                resolve(r)
            })
        })
    }
    const [state, setState] = useState({ isLoading: false, response: null, post: trigger(post), put: trigger(put), del: trigger(del) })

    return state
}
